/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { CheckboxComponent } from '../../NDC/component/NDCDetails/CMSDrug/CMSDrugInputContainer';

export default function ClaimOthers(props) {
  const { claimDetails } = props;

  function formatNDC(labelerCode, productCode, packageSize) {
    const parts = [];
    if (labelerCode !== null && labelerCode !== undefined) {
      parts.push(labelerCode);
    }
    if (productCode !== null && productCode !== undefined) {
      parts.push(productCode);
    }
    if (packageSize !== null && packageSize !== undefined) {
      parts.push(packageSize);
    }

    return parts.join('-');
  }
  const raw_ndc = formatNDC(
    claimDetails?.otherInfo?.labelerCode,
    claimDetails?.otherInfo?.productCode,
    claimDetails?.otherInfo?.packageSize
  );

  return (
    <div>
      <fieldset className="custom-fieldset">
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="prescription_number"
                label="Prescription Number:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.prescriptionNum || ''}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="basis_for_reimbursement_code"
                label="Basis For Reimbursement Code:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.basisForReimbursementCd || ''}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="number_of_refill"
                label="Number of Refill:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.numOfRefills || ''}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="days_supply"
                label="Days Supply:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.suppliedDays || ''}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="number_of_units"
                label="Number of Units:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.numOfUnits || ''}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="procedure_code"
                label="Procedure Code:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.procedureCd || ''}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="ndc"
                label="NDC:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={raw_ndc}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="drug_name"
                label="Drug Name:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.drugName || ''}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="rebate_program"
                label="Rebate Program:"
                fullWidth
                disabled
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                name="invoiceHandlingCd"
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.rebateProgramCd || ''}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="mmis_program"
                label="MMIS Program:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.mmisProgramCd || ''}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="funding_code"
                label="Funding Code:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.fundProgramCd || ''}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="review_type"
                label="Review Type:"
                fullWidth
                disabled
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                name="invoiceHandlingCd"
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.fundProgramCd || ''}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="review_results"
                label="Review Results:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="source_version_code"
                label="Source Version Code:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.sourceVersionCd || ''}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="medical_claim_type_code"
                label="Medical Claim Type Code:"
                fullWidth
                disabled
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                name="invoiceHandlingCd"
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.medClmTypeCd || ''}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="additional_provider_id_type"
                label="Additional Provider ID Type:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.altProviderIdTypeCd || ''}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="additional_provider_id"
                label="Additional Provider ID:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.otherInfo?.altProviderId || ''}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="form-wrapper vertical-wrapper">
              <div className="mui-custom-form no-margin min-full-width">
                <div className="sub-radio text-black sub-label">
                  <CheckboxComponent
                    label="Audits Exist"
                    checked={claimDetails?.otherInfo?.claimAuditExist == 1}
                    labelPlacement="end"
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="form-wrapper vertical-wrapper">
              <div className="mui-custom-form no-margin min-full-width">
                <div className="sub-radio text-black sub-label">
                  <CheckboxComponent
                    label="Coverage Gap Indicator"
                    checked={claimDetails?.otherInfo?.cvgGapInd == 1}
                    labelPlacement="end"
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="form-wrapper vertical-wrapper">
              <div className="mui-custom-form no-margin min-full-width">
                <div className="sub-radio text-black sub-label">
                  <CheckboxComponent
                    label="Unlimited Flag"
                    checked={claimDetails?.otherInfo?.unlmtFlag == 1}
                    labelPlacement="end"
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="form-wrapper vertical-wrapper">
              <div className="mui-custom-form no-margin min-full-width">
                <div className="sub-radio text-black sub-label">
                  <CheckboxComponent
                    label="Dispense as Written"
                    checked={claimDetails?.otherInfo?.dawInd == 1}
                    labelPlacement="end"
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="form-wrapper vertical-wrapper">
              <div className="mui-custom-form no-margin min-full-width">
                <div className="sub-radio text-black sub-label">
                  <CheckboxComponent
                    label="Long Term Care"
                    checked={claimDetails?.otherInfo?.ltcInd == 1}
                    labelPlacement="end"
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="form-wrapper vertical-wrapper">
              <div className="mui-custom-form no-margin min-full-width">
                <div className="sub-radio text-black sub-label">
                  <CheckboxComponent
                    label="Claim 340B"
                    checked={claimDetails?.otherInfo?.claim340bInd == 1}
                    labelPlacement="end"
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="form-wrapper vertical-wrapper">
              <div className="mui-custom-form no-margin min-full-width">
                <div className="sub-radio text-black sub-label">
                  <CheckboxComponent
                    label="NDC Supplemetal Exclusion IND"
                    checked={claimDetails?.otherInfo?.suppNdcExcInd == 1}
                    labelPlacement="end"
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
}
